import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { colors } from 'framework/theme/constants/colors';

import { OverlayElementProps } from './types';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

export const OverlayElement = styled.div<OverlayElementProps>(
  ({ width, offset, is_visible, duration }) => ({
    background: colors.dark[11],
    borderLeft: `1px solid ${colors.dark[9]}`,
    top: offset,
    visibility: is_visible ? 'visible' : 'hidden',
    animation: `${is_visible ? slideIn : slideOut} ${duration}ms forwards`,
    transform: is_visible ? 'none' : 'translateX(100%)',
    transition: `visibility ${duration}ms ease-in-out`,
    width,
    maxWidth: width,
  })
);
